<template>
  <section class="the-capsule">
    <b-container>
      <b-row>
        <b-col>
          <div class="contents text-center mx-auto">
            <h2 class="mb-4 pb-2 mx-lg-4">
              JORNAY PM is uniquely formulated to <br />
              help you or your child rise and shine.
            </h2>
            <p class="text-black-90 mx-lg-5 px-lg-4">
              Formulated with methylphenidate, JORNAY PM is taken in the evening
              and starts working upon waking, and lasts throughout the day, and
              into the early evening.
            </p>
            <p class="text-black-90 mx-lg-5 px-lg-4 mb-0">
              In clinical studies, some of the most common side effects were trouble sleeping, nausea, decreased appetite, mood swings, restlessness, vomiting, and headache. Talk to your healthcare provider if you experience these or other side effects while taking JORNAY&nbsp;PM.
            </p>
            <div class="details mx-auto">
              <h2 class="mb-5">
                The JORNAY PM capsule is specifically designed to start working
                upon waking.
              </h2>

              <p class="dark-text"><em>JORNAY PM capsule</em>

              </p>
              <img
                src="@/assets/images/3_25/how/capsule-1@2x.webp"
                alt="A JORNAY PM capsule open with microbeads spilling out."
                width="256"
                class="mt-4 pt-2"
              />
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="51.547"
                height="26.481"
                viewBox="0 0 51.547 26.481"
                role="presentation"
              >
                <path
                  d="M3781.268,2467l25.42,25.42,25.42-25.42"
                  transform="translate(-3780.914 -2466.646)"
                  fill="none"
                  stroke="#30368c"
                  stroke-width="1"
                />
              </svg>

              <p class="dark-text mx-lg-5 px-lg-4">
                <em>Microbead</em>
                The microbeads within each capsule of
                <span class="text-nowrap">JORNAY PM</span> have&nbsp;a unique
                structure consisting of 2 outer layers.
              </p>
              <img
                src="@/assets/images/3_25/how/capsule-2@2x.webp"
                alt="A microbead cut open to show the layers. The outer layer is the delayed-release layer."
                width="221"
                class="mt-5"
              />

              <p class="dark-text mx-lg-3 mb-0">
                <em>Delayed-release layer</em>
                The delayed-release layer keeps the medicine from working for
                about 10 hours, so it’s working upon waking up to start the day.
              </p>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="51.547"
                height="26.481"
                viewBox="0 0 51.547 26.481"
                role="presentation"
              >
                <path
                  d="M3781.268,2467l25.42,25.42,25.42-25.42"
                  transform="translate(-3780.914 -2466.646)"
                  fill="none"
                  stroke="#30368c"
                  stroke-width="1"
                />
              </svg>
              <img
                src="@/assets/images/3_25/how/capsule-3@2x.webp"
                alt="A microbead cut open to show the inner two layers. The second layer is the extended-release layer."
                width="181"
              />

              <p class="dark-text mx-lg-5 px-lg-5 mb-0">
                <em>Extended-release layer</em>
                The extended-release layer delivers steady ADHD symptom support
                throughout the day.
              </p>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="51.547"
                height="26.481"
                viewBox="0 0 51.547 26.481"
                role="presentation"
              >
                <path
                  d="M3781.268,2467l25.42,25.42,25.42-25.42"
                  transform="translate(-3780.914 -2466.646)"
                  fill="none"
                  stroke="#30368c"
                  stroke-width="1"
                />
              </svg>
              <img
                src="@/assets/images/3_25/how/capsule-4@2x.webp"
                alt="The inner medicine core of the microbead."
                width="135"
              />

              <p class="dark-text mx-lg-5 px-lg-4 mb-0">
                <em>Medicine core</em>
                At its core, JORNAY PM is formulated with methylphenidate—a
                well-studied medicine that has been prescribed for patients with
                ADHD for decades.
              </p>
            </div>
          </div>
          <div class="callout bg-gradient">
            <div class="callout__contents">
              <p class="fw-extrabold m-0 text-center">
                Here’s something to remember: Everyone’s body is different.
                That’s why it’s important to work with your healthcare provider
                to learn more about
                <span class="text-nowrap">JORNAY PM</span> and see if it is the
                right treatment option for you.
              </p>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {};
</script>
